import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';

interface IInstantCheckoutSetUpButton {
  onSetup: () => void;
}
export const SetupButton = ({ onSetup }: IInstantCheckoutSetUpButton) => {
  return (
    <Button fullWidth onClick={onSetup}>
      Set Up Where You Get It
    </Button>
  );
};
